module.exports = __webpack_public_path__ + "static/media/relationship.93a42385.jpg";